import React from 'react';
import Calendar from 'rc-calendar';
import moment from 'moment-timezone';
import en_US from 'rc-calendar/lib/locale/en_US';
import { uid } from 'react-uid';
import 'rc-calendar/assets/index.css';
import type { Moment } from 'moment';
import { StyledWrapper } from './styles';

type TDatePickerCalendarProps = {
    selectedDate: Moment | undefined;
    handleCheckIsDateDisabled?: (current: Moment | null | undefined) => boolean;
    onDateSelect: (current: Moment | null) => void;
    timeZone: string;
};

const locale = { ...moment.updateLocale('en', { week: { dow: 1 } }), ...en_US };

export const DatePickerCalendar = (props: TDatePickerCalendarProps) => {
    const { selectedDate, onDateSelect, handleCheckIsDateDisabled, timeZone } = props;

    const momentDate = selectedDate ? moment(selectedDate).tz(timeZone) : moment().tz(timeZone);

    return (
        <StyledWrapper className="elmo-calendar">
            <Calendar
                key={uid(locale)}
                defaultValue={momentDate}
                onSelect={(date) => {
                    if (date) {
                        onDateSelect(date);
                    }
                    document.body.click();
                }}
                showDateInput={false}
                locale={locale}
                disabledDate={(current) => {
                    if (typeof handleCheckIsDateDisabled === 'function') {
                        return handleCheckIsDateDisabled(current);
                    }
                    return false;
                }}
            />
        </StyledWrapper>
    );
};
